import { Injectable, inject } from '@angular/core';

import { IconInfo, Message } from '@frontend/sports/betting-offer/feature/model';
import { BookieTickerConfig } from '@frontend/sports/common/client-config-data-access';
import { DateTimeParser } from '@frontend/sports/common/core/feature/date-time-parser';
import { isEmpty } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class MessageParser {
    private dateParser = inject(DateTimeParser);

    parseMessages(messages: Message[], sportId: number, skipTime?: boolean): Message[] {
        const result: Message[] = [];

        if (!messages || messages.length === 0) {
            return result;
        }

        for (const message of messages) {
            let time = message.time;
            let icon = message.icon;

            if (time && !skipTime) {
                time = this.dateParser.getTime(Number(message.time));
            }

            result.push({
                icon,
                text: message.text,
                time,
                type: message.type,
                order: message.order,
                teamType: message.teamType,
            });
        }

        return result;
    }

    getIcon(message: Message, sportId: number, icons: BookieTickerConfig['messageIcons']): IconInfo | undefined {
        if (message.icon) {
            return message.icon;
        }

        if (isEmpty(icons)) {
            return undefined;
        }

        return this.processIcon(message.type, sportId, icons);
    }

    private processIcon(messageType: number, sportId: number, icons: BookieTickerConfig['messageIcons']): IconInfo | undefined {
        const icon = this.getIconFromConfig(messageType, sportId, icons);

        if (icon && messageType > 1) {
            icon.name = `sports-sb-${icon.name}`;
        }

        return icon;
    }

    private getIconFromConfig(messageType: number, sportId: number, icons: BookieTickerConfig['messageIcons']): IconInfo | undefined {
        if (messageType === 0) {
            return;
        }

        if (messageType === 1) {
            return icons['0']?.['1'];
        }

        const id = sportId.toString();
        const type = messageType.toString();
        const icon: IconInfo = { name: '', color: '' };

        if (icons?.[id]?.[type]) {
            icon.color = icons[id][type].color;
            icon.name = icons[id][type].name;
            icon.highlight = icons[id][type].highlight;

            return icon;
        }

        return undefined;
    }
}
